import { Skill } from "./types";

export const SkillBarter: Skill = {
  name: "Barter",
  levels: [0, 10, 20, 30]
}